import { createHoldingRentalMutation } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useHoldingRentalMutation = createHoldingRentalMutation(HTTP_CONFIG.API.Consumer.url)
